/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} L6_Hero_EyebrowInputs */

const es_l6_hero_eyebrow = /** @type {(inputs: L6_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charter · Lista 6ª`)
};

const gl_l6_hero_eyebrow = /** @type {(inputs: L6_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charter · Lista 6ª`)
};

const en_l6_hero_eyebrow = /** @type {(inputs: L6_Hero_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Charter · List 6`)
};

/**
* | output |
* | --- |
* | "Charter · List 6" |
*
* @param {L6_Hero_EyebrowInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const l6_hero_eyebrow = /** @type {((inputs?: L6_Hero_EyebrowInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<L6_Hero_EyebrowInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_l6_hero_eyebrow(inputs)
	if (locale === "en") return en_l6_hero_eyebrow(inputs)
	return es_l6_hero_eyebrow(inputs)
});